import Route from '@ember/routing/route';

export default class PslfIndexRoute extends Route {}
